import React from "react";
import Description from "./components/Description";

const Plotle = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="w-full px-4 text-center">
        <h1 className="text-3xl font-bold">Plotle</h1>
        <Description />
      </div>
    </div>
  );
};

export default Plotle;
